import React, { useEffect, useState, useMemo } from 'react';
import { Backdrop, IconButton, Snackbar, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MobileInProgress from './SvgIcons/MobileInProgress';

const MobileToastMessage = () => (
  <Stack spacing={2} alignItems="center" textAlign="center">
    <MobileInProgress />
    <Typography sx={{ fontWeight: 600, fontSize: '1.25rem', color: '#12AFB8' }}>
      Hey there! 👋
    </Typography>
    <Typography sx={{ fontWeight: 600, fontSize: '1.5rem', color: '#12AFB8' }}>
      Get the best view on desktop
    </Typography>
    <Typography sx={{ fontWeight: 500, fontSize: '1rem', lineHeight: 1.6 }}>
      GenPT isn’t mobile-ready just yet. We’re still perfecting the GenPT experience for smaller screens. For the best view, please continue on your laptop or desktop.
    </Typography>
  </Stack>
);

const snackbarStyles = {
  backgroundColor: '#FFFFFF',
  color: '#000000',
  fontWeight: 600,
  width: '65vw',
  maxWidth: 520,
  borderRadius: '12px',
  boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.15)',
  padding: '32px',
  position: 'relative',
};

const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;
  const mobileViewport = window.matchMedia?.('(max-width: 768px)').matches;
  const mobileAgent = /Mobi|Android|iPhone|iPad|iPod/i.test(window.navigator?.userAgent || '');
  return mobileViewport || mobileAgent;
};

const MobileExperienceToast = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isMobileDevice()) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => setOpen(false);

  const snackbarPosition = useMemo(
    () => ({
      vertical: 'top',
      horizontal: 'center',
    }),
    []
  );

  return (
    <>
      <Backdrop
        open={open}
        sx={{ zIndex: 1300, backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
        onClick={handleClose}
      />
      <Snackbar
        open={open}
        autoHideDuration={10000}
        anchorOrigin={snackbarPosition}
        sx={{ top: '50% !important', transform: 'translateY(-50%)' }}
        onClose={handleClose}
        ContentProps={{ sx: snackbarStyles }}
        message={<MobileToastMessage />}
        action={
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8, color: '#228EBC' }}
          >
            <CloseIcon />
          </IconButton>
        }
      />
    </>
  );
};

export default MobileExperienceToast;

